<p-dialog
  [(visible)]="showDialog"
  [modal]="true"
  [style]="{ width: '700px', padding: '0' }"
  [contentStyle]="{ padding: '0' }"
  [header]="dialogHeader"
  (onHide)="onCloseDialog()"
>
  <route-itinerary
    [routeId]="selectedRoute?.id"
    (alternateRouteSelected)="onAlternateRouteSelected($event)"
    [fullWidth]="true"
    [routeGrabbed]="selectedRoute?.routeGrabbed"
  ></route-itinerary>
  <p-footer>
    <div class="flex justify-content-between">
      <div class="route-itinerary-start-date-container">
        <div class="route-itinerary-start-date-label">Start Date & Time</div>
        <div class="route-itinerary-start-date-value">
          {{ selectedRoute?.leaveHomeEarliest | date : 'EEE, d MMM H:mm' }} -
          {{ selectedRoute?.leaveHomeLatest | date : 'H:mm' }}
        </div>
      </div>

      <div class="my-auto gap-4">
        <button
          pButton
          label="Route Details"
          (click)="routeDetailClick.emit()"
          class="ui-button-secondary"
        ></button>
        <button
          *ngIf="!selectedRoute?.routeGrabbed"
          pButton
          [label]="isVME ? 'Deploy Route' : 'Grab Route'"
          (click)="grabOrDeployRouteClick.emit()"
          class="ui-button-primary"
        ></button>
      </div>
    </div>
  </p-footer>
</p-dialog>
